import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]

import AppAlert from "@/components/AppAlert.vue";
import {computed, ref} from "vue";
import {useStore} from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPasswordForgotModal',
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ["ok", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const store = useStore()

const email = ref<string>('')

const configuration = computed(() => store.state.configuration)
if (configuration.value) {
  email.value = configuration.value.user.email
}

const onOk = () => {
  emit('ok', email.value)
  email.value = ''
}
const onCancel = () => {
  emit('cancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppAlert, {
    show: _ctx.show,
    title: "Passwort vergessen",
    "show-cancel": "",
    onOk: onOk,
    onCancel: onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "form",
        onSubmit: _withModifiers(onOk, ["prevent"])
      }, [
        _createElementVNode("label", null, [
          _createTextVNode(" E-Mail Adresse "),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            autofocus: ""
          }, null, 512), [
            [_vModelText, email.value]
          ])
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})